import CryptoCurrencyPage from '@/components/CryptoCurrency/CryptoCurrencyPage';

import router from './index';

router.addRoute({
  path: '/price/:crypto',
  name: 'cryptoCurrencyPage',
  component: CryptoCurrencyPage,
  props: {
    default: true,
  },
});

export default router;
